import { gql } from 'graphql-request'

import graphQLRequest from '@/CandidateExperience/config/graphQLRequest'

const CREATE_POSITION_FEEDBACK = gql`
  mutation createRecommendedPositionFeedback($input: CreateRecommendedPositionFeedbackInput!) {
    createRecommendedPositionFeedback(input: $input) {
      feedback {
        validRecommendation
      }
    }
  }
`

export const createPositionFeedback = async ({ candidateProfileId, positionId, validRecommendation }) => {
  const data = await graphQLRequest(CREATE_POSITION_FEEDBACK, {
    input: {
      feedback: {
        candidateProfileId,
        positionId,
        validRecommendation,
      },
    },
  })

  return data
}

const FETCH_FEEDBACK = gql`
  query recommendationFeedback($candidateProfileId: ID!, $positionId: ID!) {
    position(id: $positionId) {
      feedback(candidateProfileId: $candidateProfileId) {
        id
      }
    }
  }
`

export const fetchRecommendationFeedback = ({ candidateProfileId, positionId }) => {
  return graphQLRequest(FETCH_FEEDBACK, { candidateProfileId, positionId })
}
